import ReferenceList from '../ReferenceList/ReferenceList'

export default function AppObjectFieldRefList(props) {
  const { formInputs, object, field, action } = props
  console.log('AppObjectFieldRefList rendered: ', props)

  return (
    <ReferenceList formInputs={formInputs} object={object} field={field} action={action} />
  )
}
